import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Der blev fundet ")
const _hoisted_2 = { class: "text-primary" }
const _hoisted_3 = { class: "pt-3 pb-3 d-flex justify-content-between align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Der blev fundet ")
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = /*#__PURE__*/_createVNode("strong", null, "Opret rolle", -1)
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "ms-2 text-muted" }
const _hoisted_9 = { class: "pt-3 pb-3 d-flex justify-content-between align-items-center" }
const _hoisted_10 = { class: "text-primary" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "ms-2 text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_application_modal = _resolveComponent("application-modal")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_VDButton = _resolveComponent("VDButton")!
  const _component_error = _resolveComponent("error")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_o_tab_item = _resolveComponent("o-tab-item")!
  const _component_o_tabs = _resolveComponent("o-tabs")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_application_modal, { ref: "applicationModal" }, null, 512),
    _createVNode(_component_page, {
      isLoading: _ctx.loading,
      error: _ctx.error
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeader, {
          title: _ctx.application?.name,
          titleButtonIcon: _ctx.canEditApp ? 'edit' : undefined,
          onOnTitleButton: _cache[1] || (_cache[1] = ($event: any) => (_ctx.application ? _ctx.applicationModal?.show(_ctx.application) : null)),
          classContainerAppHeader: 'mt-5'
        }, {
          titleDetails: _withCtx(() => []),
          tab: _withCtx(() => [
            _createVNode("strong", null, [
              _hoisted_1,
              _createVNode("span", _hoisted_2, _toDisplayString(_ctx.application?.roles?.length), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.usePluralFilter(_ctx.application?.roles?.length, "rolle", "roller")), 1)
            ])
          ]),
          _: 1
        }, 8, ["title", "titleButtonIcon"]),
        _createVNode(_component_o_tabs, {
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeTab = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_o_tab_item, {
              value: _ctx.applicationTabs.Roles,
              label: _ctx.$translate('TextResources_Roles')
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_3, [
                  _createVNode("strong", null, [
                    _hoisted_4,
                    _createVNode("span", _hoisted_5, _toDisplayString(_ctx.application?.roles?.length), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.usePluralFilter(_ctx.application?.roles?.length, "rolle", "roller")), 1)
                  ]),
                  (_ctx.canManageRoles)
                    ? (_openBlock(), _createBlock(_component_VDButton, {
                        key: 0,
                        class: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'role', params: { id: 'new' } })))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_DataTable, {
                  sortField: "name",
                  sortOrder: 1,
                  value: _ctx.application?.roles ?? [],
                  selectionMode: "single",
                  onRowClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.canManageRoles && _ctx.editRole($event.data)))
                }, {
                  empty: _withCtx(() => [
                    _createVNode(_component_error, { error: {
                title: 'Ingen roller',
                message:
                  'Der er ikke oprettet nogle roller tilknyttet denne applikation endnu',
              } })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, { bodyStyle: "width: 3rem" }, {
                      body: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          size: "xs",
                          class: "me-4 text-secondary",
                          icon: ['fas', 'circle']
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "name",
                      columnKey: "roleName"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("div", _hoisted_7, [
                          _createVNode("strong", null, _toDisplayString(data.name), 1),
                          _createVNode("span", _hoisted_8, "| " + _toDisplayString(data.description), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["value", "label"]),
            _createVNode(_component_o_tab_item, {
              value: _ctx.applicationTabs.Profiles,
              label: _ctx.$translate('TextResources_Profiles')
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_9, [
                  _createVNode("strong", null, [
                    _createTextVNode(_toDisplayString(_ctx.$translate("TextResources_FoundNumberProfile")) + " ", 1),
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.application?.profiles?.length), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.usePluralFilter(
                _ctx.application?.profiles?.length,
                _ctx.$translate("TextResources_Profile").toLowerCase(),
                _ctx.$translate("TextResources_Profiles").toLowerCase()
              )), 1)
                  ]),
                  (_ctx.canManageRoleProfiles)
                    ? (_openBlock(), _createBlock(_component_VDButton, {
                        key: 0,
                        class: "primary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'profile', params: { id: 'new' } })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode("strong", null, _toDisplayString(_ctx.$translate("TextResources_CreateProfile")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_DataTable, {
                  sortField: "name",
                  sortOrder: 1,
                  value: _ctx.application?.profiles ?? [],
                  responsiveLayout: "scroll",
                  selectionMode: "single",
                  onRowClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.canManageRoleProfiles && _ctx.editProfile($event.data)))
                }, {
                  empty: _withCtx(() => [
                    _createVNode(_component_error, {
                      error: {
                title: _ctx.$translate('TextResources_EmptyProfile'),
                message: _ctx.$translate('TextResources_EmptyProfileDescription'),
              }
                    }, null, 8, ["error"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, { bodyStyle: "width: 3rem" }, {
                      body: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          size: "xs",
                          class: "text-secondary",
                          icon: ['fas', 'circle']
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "name",
                      columnKey: "profileName"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("strong", null, _toDisplayString(data.name), 1),
                          _createVNode("span", _hoisted_12, "| " + _toDisplayString(data.levelOfUse == "USER" ? "Bruger" : "Organisation") + " | " + _toDisplayString(data.description), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["value", "label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["isLoading", "error"])
  ], 64))
}